<template>
  <div>
    <div class="footer footer-section">
      <div class="container">
        <div class="footer-list">
            <p class="p1" style="margin-top:30px;margin-bottom:10px">
              <span>客服热线：0755-26788010</span>
              <span>公司地址：深圳市南山区高新南七道深圳软件园T3-B 5楼502</span>
            </p>
            <p class="p2" style="margin-bottom:30px">
              <span><a href="http://beian.miit.gov.cn" target="_blank">粤ICP备15112126号</a></span>
			        <span>2021 ©深圳市华商数据科技有限公司</span>
              <span><a href="https://saas-assets.usoftchina.com/docs/ISO27001.pdf" target="_blank">ISO27001信息安全管理体系认证</a></span>
            </p>
			      <div class="company-logo">
              <img src="/static/img/usoft_weixin_qr.png" alt />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    problem() {
      this.$router.push({ name: "Home", params: { isporblem: false } });
      this.$store.commit("problemfalse");
      $(document).scrollTop(0);
    },
    gohome() {
      this.$store.commit("problemtrue");
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue